export function canMakeApplePayPayments({ applePayMerchantIdentifier, onResult }) {
  let applePaySessionAvailable = false

  try {
    applePaySessionAvailable = window.ApplePaySession?.canMakePayments()
  } catch (error) {
    window.console?.log(`Cannot use Apple Pay: ${error.message}`)
  }

  if (applePaySessionAvailable) {
    const promise = window.ApplePaySession.canMakePaymentsWithActiveCard(applePayMerchantIdentifier)
    promise.then(canMakePayments => {
      if (canMakePayments) onResult(true)
      else onResult(false)
    })
  } else {
    onResult(false)
  }
}
